/**
 * Catalogue section types
 * @see https://webshop.pages.tech.lastmile.com/#webshop-product-ordering/sorting-sections-and-filters/sections/
 *
 * @typedef {string} SectionType
 * @enum {SectionType}
 */

const SectionType = Object.freeze({
  // standard ribbons
  ADVERT: 'ADVERT',
  ADVERT_ALT: 'ADVERT_ALT',
  CONTENT: 'CONTENT',
  CROSS_SELL: 'CROSS_SELL',
  EXTERNAL: 'EXTERNAL',
  EXTERNAL_ALT: 'EXTERNAL_ALT',
  FAVOURITES: 'FAVOURITES',
  FEATURED: 'FEATURED',
  FEATURED_AFTER_FAVS: 'FEATURED_AFTER_FAVS',
  NEW: 'NEW',
  ON_OFFER: 'ON_OFFER',
  OTHER: 'OTHER',
  PROMO_BOX: 'PROMO_BOX',
  RECOMMENDATIONS: 'RECOMMENDATIONS',
  SUBSCRIPTIONS: 'SUBSCRIPTIONS',
  SUGGESTED_ORDER: 'SUGGESTED_ORDER',

  // before you go
  HYRO_ITEMS: 'HYRO_ITEMS',
  FORGOTTEN_ITEMS: 'FORGOTTEN_ITEMS',
  INCOMPLETE_OFFERS: 'INCOMPLETE_OFFERS',
  OFFERS_ON_FAVS: 'OFFERS_ON_FAVS',
  TOP_OFFERS_BESTSELLERS: 'TOP_OFFERS_BESTSELLERS',
  TRY_SOMETHING_NEW: 'TRY_SOMETHING_NEW',
  FLASH_SALES: 'FLASH_SALES',
  SPECIAL_OFFERS: 'SPECIAL_OFFERS',
  PERSONALISED_COUPONS: 'PERSONALISED_COUPONS',

  // cluster
  CLUSTER: 'CLUSTER',

  // temperature
  AMBIENT: 'AMBIENT',
  CHILLED: 'CHILLED',
  FROZEN: 'FROZEN',

  // BOP
  YOU_MIGHT_LIKE: 'YOU_MIGHT_LIKE',
  SIMILAR_PRODUCTS: 'SIMILAR_PRODUCTS',
});

export default SectionType;

export const FIXED_TITLE_SECTIONS = [
  SectionType.FEATURED,
  SectionType.FEATURED_AFTER_FAVS,
  SectionType.ON_OFFER,
];
